module.exports = {"610929100":"城关镇","610929101":"中厂镇","610929102":"构扒镇","610929103":"卡子镇","610929104":"茅坪镇","610929105":"宋家镇","610929106":"西营镇","610929107":"仓上镇","610929108":"冷水镇","610929109":"双丰镇","610929110":"麻虎镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610929.json
// module id = 2882
// module chunks = 0